// lib/locales JSON은 named import로만 가져온다 — 동적 import로 읽으면 tree-shaking이 안 돼 JSON 전체가 청크에 들어간다.
import { packages } from '#lib/locales/ko.json';
import cueMessages from '../locales/ko';
import { withAllibeePackages } from '../_utils';

export default withAllibeePackages(packages, cueMessages);
